<template>
  <div :class="{
    'topbar': true,
    'is-beta': $config.isBeta,
    'is-update-available': updateAvailable
  }">
    <svg
      class="logo"
      @click="goToDashboard()">
      <use xlink:href="#bookero-logo" />
    </svg>

    <offline @detected-condition="handleConnectivityChange"></offline>

    <div v-if="!appIsOnline && !updateAvailable" class="no-internet-connection">
      <icon
          name="exclamation"
          size="xxs"
          primaryColor="color-light" />
      <span>
        {{ $t('topBar.noInternetConnection') }}
      </span>
    </div>

    <topbar-search
      v-if="!isMobile && !updateAvailable" />
    <topbar-user
      v-if="!updateAvailable" />

    <span
      v-if="updateAvailable"
      class="topbar-update-available">
      <span>
        {{ $t('topBar.updateAvailable') }}
      </span>

      <btn
        @click.native="refreshApp()"
        type="small with-icon"
        iconName="loader"
        iconSize="xs"
        iconColor="color-success">
        {{ $t('topBar.refreshApp') }}
      </btn>
    </span>
  </div>
</template>

<script>
import ErrorUtils from './../helpers/ErrorUtils.js';
import VOffline from 'v-offline';
import Responsive from './../mixins/Responsive';
import TopBarSearch from './TopBarSearch';
import TopBarUser from './TopBarUser';

export default {
  name: 'topbar',
  mixins: [
    Responsive
  ],
  components: {
    'topbar-search': TopBarSearch,
    'topbar-user': TopBarUser,
    'offline': VOffline
  },
  data () {
    return {
      appIsOnline: true,
      updateAvailable: false
    };
  },
  mounted () {
    this.$http.post('/panel/general/get-configuration').then(response => {
      this.$store.commit('config/setConfig', response.data);
      this.$root.defaultCurrency = response.data.default_currency;
      this.$root.renewCurrency = response.data.renew_currency;
      this.$bus.$emit('configuration-loaded');
    }).catch(error => {
      ErrorUtils.handleLoadError(error, '/panel/general/get-configuration', this.$router, this.$bus);
    });

    this.$bus.$on('bookero-new-version-available', this.displayUpdateNotice);
  },
  methods: {
    goToDashboard () {
      this.$router.push('/dashboard');
    },
    handleConnectivityChange (status) {
      this.appIsOnline = status;
    },
    displayUpdateNotice () {
      console.log('Update available!');
      this.updateAvailable = true;
    },
    refreshApp () {
      window.location.reload();
    }
  },
  beforeDestroy () {
    this.$bus.$off('bookero-new-version-available', this.displayUpdateNotice);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.topbar {
  align-items: center;
  background: $color-primary;
  display: flex;
  height: 7rem;
  left: 0;
  padding: 0 3.5rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;

  &.is-beta {
    &:after {
      background: $color-danger;
      color: $color-light;
      content: "BETA";
      display: block;
      font-size: 1.2rem;
      font-weight: bold;
      height: 20px;
      left: 0;
      line-height: 20px;
      position: absolute;
      text-align: center;
      top: 0;
      transform: translateX(-32px) translateY(8px) rotate(-45deg);
      width: 100px;
      z-index: 10;
    }
  }

  &.is-update-available {
    background: darken($color-danger, 10%);
  }

  &-update-available {
    align-items: center;
    display: flex;
    margin: 0 auto;
    padding: 0 1rem;

    span {
      color: $color-light;
      font-weight: bold;
    }

    .button {
      margin-left: 1rem;
      position: relative;
      top: 1px;
    }
  }

  .logo {
    cursor: pointer;
    height: 2.4rem;
    position: relative;
    width: 13rem;
  }

  .no-internet-connection {
    background: $color-danger;
    border-radius: 0 0 $border-radius-small $border-radius-small;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .5);
    color: $color-light;
    left: 50%;
    padding: 7px 15px;
    position: absolute;
    transform: translateX(-50%);
    top: 0;
    white-space: nowrap;
    z-index: 10000000;
  }
}

@media (max-width: 1680px) {
  .topbar {
    padding: 0 2rem;
  }
}

@media (max-width: 1240px) {
  .topbar {
    padding: 0 1rem 0 2rem;
  }
}

@media (max-width: 1024px) {
  .topbar-update-available {
    padding: 0 1rem 0 3rem;

    span {
      font-size: 1.4rem;
    }
  }
}

@media (max-width: 960px) {
  .topbar.is-update-available {
    padding: 0 1rem;
    .logo{
      display: none;
    }
  }

  .topbar-update-available {
    padding: 0 1rem;

    .button {
      top: 0;
    }
  }
}

@media (max-width: 640px) {
  .topbar {
    height: 5rem;
  }
}

@media (max-width: 480px) {
  .topbar-update-available {
    span {
      font-size: 1.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/TopBar.vue